// extracted by mini-css-extract-plugin
module.exports = {"cls1":"HorizontalRule-module--cls1--19WNJ","cls2":"HorizontalRule-module--cls2--1bL7v HorizontalRule-module--cls1--19WNJ"};